import { Helmet } from 'react-helmet'
import { ImportLogExportButton, ImportLogTable } from 'components/logsImport'

const ImportLog = () => {
  return (
    <>
      <Helmet>
        <title>ORMS Import Logs </title>
      </Helmet>
      <ImportLogExportButton />
      <ImportLogTable />
    </>
  )
}

export default ImportLog
